import _ from 'lodash';

import { DocumentType, DocumentsSource, EntityType, LATEST_REUSABLE_LAYOUT_VERSION, isVeevaMedcomms } from 'const';
import { createBrandDefinition } from 'factories/brandDefinitionFactory';
import { ReusableLayout } from 'models';
import { baseDocumentFactory } from './baseDocumentFactory';

export function layoutDocumentFactory(args = {} as Partial<ReusableLayout>): ReusableLayout {
  const {
    previewUrl = null,
    documents,
    isEdited = false,
    documentSource = [DocumentsSource.COMPONENTS],
    renditions = {},
    needToUpdatePreview = false,
    audienceType = [],
    channelType = [],
    contentType = [],
  } = args;
  const entities = _.defaults(args.entities, { brandDefinition: createBrandDefinition(), version: LATEST_REUSABLE_LAYOUT_VERSION });

  const layoutDocument: ReusableLayout = {
    ...baseDocumentFactory(args),
    type: DocumentType.COMPONENT,
    entityType: EntityType.LAYOUT,
    documentSource,
    previewUrl,
    documents,
    entities,
    isEdited,
    renditions,
    needToUpdatePreview,
  };

  if (isVeevaMedcomms()) {
    layoutDocument.audienceType = audienceType;
    layoutDocument.channelType = channelType;
    layoutDocument.contentType = contentType;
  }

  return layoutDocument;
}
